import { ANSWER_STATUSES } from '../constants';

import { RobotContext } from './context';

export const getIsReadOnly = (s: RobotContext): boolean => {
    const isAnsweredCorrectly = s.attempt?.status === ANSWER_STATUSES.CORRECT;
    const isTeacherMode = s.teacherMode;
    const isReadOnlyState = s.readOnly === true;

    return isAnsweredCorrectly || isTeacherMode || isReadOnlyState;
};
